
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/converter/express-to-canva",
      function () {
        return require("private-next-pages/converter/express-to-canva.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/converter/express-to-canva"])
      });
    }
  